
import MyImg from '../assets/avatar.png'
import Character_design from '../assets/my portfolio design copy-01.svg'
import logo_and_brading from '../assets/my portfolio design copy-02.svg'
import illustraction from '../assets/my portfolio design copy-03.svg'
import graphic_design from '../assets/my portfolio design copy-04.svg'
import user_interface from '../assets/my portfolio design copy-05.svg'
import Editional from '../assets/my portfolio design copy-06.svg'
import Cmmunication from '../assets/my portfolio design copy-07.svg'
import motion from '../assets/my portfolio design copy-08.svg'
import work3 from '../assets/work-3.svg'
import work6 from '../assets/work-6.svg'
import fivver from '../assets/fiverr.svg'
import photoShop from '../assets/photoshop.svg'
import illustartor from "../assets/ill.svg"
import preme from '../assets/preme.svg'
import after from '../assets/after.svg'

export const images={
    MyImg,
    fivver,
    photoShop,
    illustartor,
    preme,
    after
}

export const services=[{
        id: 1,
        image: graphic_design,
        title: 'Character Design' 
    }, 
    {
        id: 2,
        image: illustraction,
        title: 'Logo and Branding' 
    },
    {
        id: 3,
        image: logo_and_brading,
        title: 'Illustartion' 
    },
    {
        id: 4,
        image: Character_design,
        title: 'Graphic Design' 
    },
    {
        id: 5,
        image: motion ,
        title: 'User Interface' 
    },
    {
        id: 6,
        image: Cmmunication,
        title: 'Editorial Layout' 
    },
    {
        id: 7,
        image: Editional,
        title: 'Communication' 
    },
    {
        id: 8,
        image: user_interface,
        title: 'Motion Graphic' 
    }]

export const resum=[
    {
        id: 1,
        category:"education",
        year:'2018-2021',
        title:'Engineer in geodetic and topographical science - Civil engineering ',
        place:'Special techniques center -CTS - Oran, Algeria',
    },
    {
        id: 2,
        category:"experience",
        year:'2017-present',
        title:'Freelance Designer ',
        place:'Fiverr -Freelance',
    },
    {
        id: 3,
        category:"experience",
        year:'2021-present',
        title:'Lead Designer',
        place:'WeOne IT',
    }
]

export const WorkMenu=[
    {
        id: 1,
        category: 'Visual idantity',
        title: 'WEONEIT Visual idantity ',
        image: 'https://mir-s3-cdn-cf.behance.net/projects/404/7aa0e9144059545.Y3JvcCwxMjQzLDk3MiwxMiwxMzk4NA.png',
        link:'https://www.behance.net/gallery/144059545/WEONEIT-visual-idantity'
    },
    {
        id: 2,
        category: 'banner',
        title: 'Gaming Banner for twitch and Youtub',
        image:'	https://mir-s3-cdn-cf.behance.net/projects/404/7c4ac6132308907.Y3JvcCw4NjAsNjczLDcwLDA.jpg',
        link :'https://www.behance.net/gallery/132308907/gaming-banner-for-twitch-and-youtube'
    },
    {
        id: 3,
        category: 'logos',
        title: 'Gaming logo and banner',
        image:'	https://mir-s3-cdn-cf.behance.net/project_modules/fs/338cea132308651.61a677f78fe16.jpg',
        link:'https://www.behance.net/gallery/132308651/gaming-logo-and-banner-for-twitch-and-youtube?tracking_source=project_owner_other_projects'
    },
    {
        id: 4,
        category: 'logos',
        title: 'Gaming logo and Banner',
        image:'https://mir-s3-cdn-cf.behance.net/projects/max_808/913ad8132308451.Y3JvcCwxODQxLDE0NDAsMzYwLDA.jpg',
        link: 'https://www.behance.net/gallery/132308451/gaming-logo-and-banner-for-youtube-and-twitch'
    },
    {
        id: 5,
        category: 'logos',
        title: 'Gamming Logo and Banner',
        image:'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/e836c9132307645.61a674390297a.jpg',
        link: 'https://www.behance.net/gallery/132307645/gaming-logo-and-banner-for-youtube-and-twitch'
    },
    {
        id: 6,
        category: 'banner',
        title: 'Youtub and twitch gaming banner',
        image:'https://mir-s3-cdn-cf.behance.net/project_modules/fs/fb4d06132307283.61a672f6ad5e7.jpg',
        link: 'https://www.behance.net/gallery/132307283/youtube-and-twitch-gaming-banner'
    },
    {
        id: 7,
        category: 'banner',
        title: 'Logos and Youtub and twitch gaming banner',
        image:'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b3eea4130305047.617d1f287cf64.jpg',
        link:'https://www.behance.net/gallery/130305047/gaming-logo-an-twitch-banner-for-poor_solution'
    },
    {
        id: 8,
        category: 'banner',
        title: 'Twitch banner ',
        image:'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/d631c8130672447.618514ee663ca.jpg',
        link: 'https://www.behance.net/gallery/130672447/twitch-banner'
    },
    {
        id: 9,
        category: 'Illustration',
        title: 'Funny Illustration for KIDS',
        image:'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/3c1a9e130566857.6182ce059d09d.jpg',
        link: 'https://www.behance.net/gallery/130566857/funny-illustration-for-kids'
    },
    {
        id: 10,
        category: 'Visual idantity',
        title: 'BIOCOS eStore',
        image:work6,
        link: 'https://www.instagram.com/biocos_/'
    },
    {
        id: 11,
        category: 'poster',
        title: 'Cammilia school',
        image:work3,
        link: 'https://www.instagram.com/ecole_camelia/'
    }
]
